module.exports = "https://cwa.roocdn.com/_next/static/kw.a7d7a9bc.png";